


import React from 'react';
import useTranslationWithFallback from '../hooks/useTranslationWithFallback';

const TranslatedText = ({ children, className, tag: Tag = React.Fragment, ...props }) => {
  const translated = useTranslationWithFallback(children);

  // If a class or specific tag is provided (and it's not Fragment), render the element
  if (className || (Tag !== React.Fragment)) {
    // If Tag is Fragment but class is provided, default to span
    const Element = Tag === React.Fragment ? 'span' : Tag;
    return <Element className={className} {...props}>{translated || children}</Element>;
  }

  return <>{translated || children}</>;
};

export default TranslatedText;